<template>
    <option value="fires">Fires</option>
    <option value="temperature">Temperature</option>
    <option value="air-quality">Air Quality</option>
    <option value="pest-disease">Pest &amp; Disease</option>
    <option value="rain">Rain</option>
    <option value="irrigation">Irrigation</option>
</template>
